exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-deal-lead-___style__container___11RWQ{display:flex}@media (max-width:599px){.web-flows-deal-lead-___style__container___11RWQ{flex-direction:column}}.web-flows-deal-lead-___style__left___1WjPT{flex:1;padding-right:1em}@media (max-width:599px){.web-flows-deal-lead-___style__left___1WjPT{padding-right:0}}.web-flows-deal-lead-___style__right___2FKtO{flex:3}@media (max-width:599px){.web-flows-deal-lead-___style__right___2FKtO{padding-top:1em}}.web-flows-deal-lead-___style__left___1WjPT button{width:100%}", ""]);

// exports
exports.locals = {
	"container": "web-flows-deal-lead-___style__container___11RWQ",
	"left": "web-flows-deal-lead-___style__left___1WjPT",
	"right": "web-flows-deal-lead-___style__right___2FKtO"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/deal/lead/style.css
// module id = 1347
// module chunks = 0